import { type ReactNode, useEffect, useRef } from 'react';

interface IProps {
  children: ReactNode;
  className?: string;
  onOutsideClick: (element: Node) => void;
}

const OutsideClickHandler = ({
  children,
  className,
  onOutsideClick
}: IProps) => {
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target as Node)
      ) {
        onOutsideClick(event.target as Node);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onOutsideClick]);

  return (
    <div ref={wrapperRef} className={className}>
      {children}
    </div>
  );
};

export default OutsideClickHandler;
